import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
var getModuleContent = function getModuleContent() {
  return document.getElementsByClassName('module-content')[0];
};

// "target" can be "window", "document.body", a "ref" or undefiend
// where in later case the module-content is taken as default

var useScrollPosition = function useScrollPosition(target) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    targetElement = _useState2[0],
    setTargetElement = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollPosition = _useState4[0],
    setScrollPosition = _useState4[1];
  useEffect(function () {
    var checkForModuleContent = null;

    // In cae the target is undefined it might be that the module-content is
    // not rendered yet, hence check periodically for the existence in the DOM
    if (!target) {
      checkForModuleContent = setInterval(function () {
        var element = getModuleContent();
        if (element) {
          setTargetElement(element);
        }
      }, 300);
    } else if (target && checkForModuleContent) {
      clearInterval(checkForModuleContent);
    }

    // In case the target is a "ref" - set the targetElement when current is defined
    else if (target !== null && target !== void 0 && target.current && !checkForModuleContent) {
      setTargetElement(target.current);
    }

    // In case it's "window" or "document.body"
    else {
      setTargetElement(target);
    }
    return function () {
      if (checkForModuleContent) {
        clearInterval(checkForModuleContent);
      }
    };
  }, [target]);
  var handleScroll = function handleScroll() {
    requestAnimationFrame(function () {
      if (targetElement === window) {
        setScrollPosition(targetElement.scrollY);
      } else {
        setScrollPosition(targetElement.scrollTop);
      }
    });
  };
  useEffect(function () {
    if (targetElement) {
      targetElement.addEventListener('scroll', handleScroll);
    }
    return function () {
      if (targetElement) {
        targetElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [targetElement]);
  return scrollPosition;
};
export default useScrollPosition;